var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "#697582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20,4 a2,2 0 0 1 2 2 v12 a2,2 0 0 1 -2 2 h-16 a2,2 0 0 1 -2 -2 v-12 a2,2 0 0 1 2, -2z M20,5 a1,1 0 0 1 1 1 v12 a1,1 0 0 1 -1 1 h-16 a1,1 0 0 1 -1 -1 v-12 a1,1 0 0 1 1, -1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10,9 v6 l2,-2 l2,2 l1,-1 l-2,-2 l2,-2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconButton);
export default __webpack_public_path__ + "static/media/icon_button.df259d1ab6aa08d82d087a3d66184192.svg";
export { ForwardRef as ReactComponent };